import { connect } from "react-redux";
import BenefitsSelection, { BenefitsSectionProps } from "./BenefitsSection.component";
import { RootState } from "../../reducers";
import { getCommonBenefits, getServiceCoverageDetails } from "../../selector";
import { updateMemberId, updatePartnerMemberId, updatePromoCode } from "../../action";

const mapStateToProps = (state: RootState) =>
  ({
    commonBenefits: getCommonBenefits(state),
    serviceCoverageDetails: getServiceCoverageDetails(state),
  } as Pick<BenefitsSectionProps, "commonBenefits" | "serviceCoverageDetails">);

export default connect(mapStateToProps, {
  updatePromoCode,
  updateMemberId,
  updatePartnerMemberId,
} as Pick<BenefitsSectionProps, "updatePromoCode" | "updateMemberId" | "updatePartnerMemberId">)(BenefitsSelection);